require('./OKHeaderCC.scss');
const { OKBreadcrumb } = require('commonsComponents/OKBreadcrumb');

const React = require('react');
const PropTypes = require('prop-types');

class OKHeaderCC extends React.Component {
    render() {
        const { title, showBreadBrumb, breadcrumbConfig, submitSuccessful, errorReceived } = this.props;

        if(showBreadBrumb){
            let itemCustomClassName;
            if(submitSuccessful || errorReceived){
                itemCustomClassName = 'ok-header-cc__breadcrumb-item-disabled'
            }else {
                itemCustomClassName = 'ok-header-cc__breadcrumb-item'
            }
            return (
                <div className="ok-header-cc">
                    <div className="ok-header-cc__breadcrumb-section">
                        <OKBreadcrumb
                            mapping={breadcrumbConfig}
                            itemCustomClassName={itemCustomClassName}
                        />
                    </div>
                </div>
            );
        }else{
            return (
                <div className="ok-header-cc">
                    <h1 className="ok-header-cc__title">
                        {title}
                    </h1>
                </div>
            );
        }
    }
}

OKHeaderCC.propTypes = {
    title: PropTypes.string,
    breadcrumbConfig: PropTypes.array,
    showBreadBrumb: PropTypes.bool,
    submitSuccessful: PropTypes.bool,
    errorReceived: PropTypes.bool
};

OKHeaderCC.defaultProps = {
    showBreadBrumb: false
}

module.exports = OKHeaderCC;
